import getFromCdn from '@anm/helpers/getFromCdn';
import styled, { css } from 'styled-components';

const greyText = css`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.01em;
`;

const enabledColor = css`
  color: #919eaa;
`;

const disabledColor = css`
  color: #e0e7eb;
`;

export const Subtitle = styled.div`
  margin-bottom: 7px;
  ${greyText};
`;

export const CopyButton = styled.div`
  margin-top: 7px;
  display: flex;
  align-items: center;
  cursor: pointer;
  ${greyText};

  &:before {
    display: block;
    content: '';
    width: 16px;
    height: 16px;
    margin-right: 4px;
    background: url(${getFromCdn('images/icons/copy_icon.svg')}) no-repeat center / cover;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const ShowButton = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  user-select: none;
  cursor: pointer;
  ${greyText}
`;

export const Wrapper = styled.div<{ disabled: boolean }>`
  ${Subtitle}, ${CopyButton}, ${ShowButton} {
    ${({ disabled }) => (disabled ? disabledColor : enabledColor)};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      ${InputWrapper} {
        input {
          background: #f3f6f7;
          border: 1px solid rgba(204, 221, 230, 0.5);
        }
      }

      ${CopyButton} {
        &:before {
          opacity: 0.2;
        }
      }
    `}
`;
